const TIME_WINDOW = 60 * 1000; // 1 minute

export const handleRateLimit = (config) => {
  const URL = config.url;
  const MAX_RATE_LIMIT = config.maxRateLimit || 10;

  const now = Date.now();
  const key = `rate_limit_${URL}`;

  let data = JSON.parse(localStorage.getItem(key)) || {
    count: 0,
    startTime: now
  };

  if (now - data.startTime > TIME_WINDOW) {
    data = { count: 0, startTime: now };
  }

  data.count += 1;
  localStorage.setItem(key, JSON.stringify(data));

  return data.count > MAX_RATE_LIMIT;
};
